// extracted by mini-css-extract-plugin
export default {"container":"galleryMain_container__-n0Jp","quoteWrapper":"galleryMain_quoteWrapper__ujkLm"};